import { Vue, Component, Prop } from "vue-property-decorator";
import isOutdatedBrowser from "../../helpers/outdated-browser";
import { router } from "../../global";

declare global {
    interface Window {
        mgnlContextPath: string;
    }
}

@Component
export default class ReferenceOverview extends Vue {
    @Prop({ type: String, default: "de" })
    public language!: string;

    @Prop({ type: String, default: "" })
    public allText!: string;

    public categories: any = {};
    public overview: any = {};
    public teasers: any[] = [];
    public currentCategory = "";
    public currentCategoryDisplayName = "";
    public isInitialized: boolean = false;
    public dropdownOpen: boolean = false;

    public isOutdatedBrowser = isOutdatedBrowser;

    public gridContainers: any = null;

    public mounted() {
        getCategories(this.language).then(data => {
            this.categories = data;
            this.updateReferences(this.$route.params.category || "");
        });

        this.gridContainers = this.$el.querySelectorAll(".grid-container");


    }

    public updateReferences(categoryID: string) {
        const time = 600;

        for ( const container of this.gridContainers ) {
            container.style.opacity = "0";
            container.style.transition = `opacity ${time}ms`;
        }


        this.closeDropdown();

        setTimeout(() => {
            router.replace(`/${categoryID}`);
            this.currentCategory = categoryID;
            this.updateCurrentCategoryDisplayName();

            getReferences(categoryID, this.language).then(data => {
                const bigTeaser = categoryID
                    ? this.categories.categories.find(
                          (entry: any) => entry.id === categoryID,
                      )
                    : this.categories.bigTeaserAll;

                this.overview = data;
                this.setupTeaser(bigTeaser ? bigTeaser.id || bigTeaser : "");

                this.isInitialized = true;
            });
        }, time);

    }


    private updateCurrentCategoryDisplayName() {
        const categoriesArray = this.categories.categories;
        if (this.currentCategory === "") {
            this.currentCategoryDisplayName = this.allText;
        } else {
            if (categoriesArray) {
                for (let i = 0; i < categoriesArray.length; i++) {
                    if (categoriesArray[i].id === this.currentCategory) {
                        this.currentCategoryDisplayName = categoriesArray[i].displayName;
                    }
                }
            }
        }
    }


    public isHigh(index: number) {
        // index += -2;
        // return index === -1 || (index % 15 % 6 === 0);
        return (
            typeof this.overview.references[index].portrait !== "undefined" &&
            JSON.parse(this.overview.references[index].portrait) === true
        );
    }

    public setupTeaser(bigTeaserID: string) {
        let firstTeaser: any;

        const otherTeasers = this.overview.references.filter((entry: any) => {
            if (entry.id === bigTeaserID) {
                firstTeaser = entry;

                return false;
            }

            return true;
        });

        this.teasers = firstTeaser
            ? [].concat(firstTeaser, ...otherTeasers)
            : otherTeasers;

        if (this.gridContainers) {
            this.$nextTick().then(() => {
                setTimeout(() => {

                    for ( const container of this.gridContainers ) {
                        container.style.opacity = "1";
                        container.style.transition = `opacity 350ms`;
                    }

                }, 600);
            });
        }
    }

    public teaserVisibility( categories: string[] ): object {
        return { "js-hidden" : this.currentCategory && !categories.includes(this.currentCategory) };
    }

    public toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }
    public closeDropdown() {
        this.dropdownOpen = false;
    }
}

function getCategories(language: string): Promise<any> {
    return fetch(`${window.mgnlContextPath}/.rest/suan/v1/categories`, {
        credentials: "include",
        method: "PUT",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        body: JSON.stringify({
            language,
        }),
    }).then(response => response.json());
}

function getReferences(categoryID: string, language: string): Promise<any> {
    return fetch(`${window.mgnlContextPath}/.rest/suan/v1/reference/overview`, {
        credentials: "include",
        method: "PUT",
        cache: "no-cache",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
        },
        body: JSON.stringify({
            category: String(categoryID || ""),
            language,
        }),
    }).then(response => response.json());
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/scripts/reference-overview.ts